import { produce } from 'immer';
import {
  SET_ACTIVE_LISTINGS,
  SET_ACTIVE_LISTINGS_ERROR,
  CLEAR_ACTIVE_LISTINGS_ERROR,
  SET_PRODUCT_VARIANTS,
} from 'store/constants/action-types';

const initialState = {
  products: null,
  metadata: null,
  status: {
    hasError: false,
    errorMessage: null,
  },
  variants: {},
};

export const activeListingsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_ACTIVE_LISTINGS:
        draft.products = action.payload.productTemplates;
        draft.metadata = action.payload.metadata;
        break;
      case SET_ACTIVE_LISTINGS_ERROR:
        draft.status.hasError = true;
        draft.status.errorMessage = action.error;
        break;
      case CLEAR_ACTIVE_LISTINGS_ERROR:
        draft.status.hasError = false;
        draft.status.errorMessage = null;
        break;
      case SET_PRODUCT_VARIANTS:
        draft.variants[action.payload.id] = action.payload.variants;
        break;
      default:
        return state;
    }
  });

export default activeListingsReducer;
